import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  menu = [
    { link: "/", text: "Home" },
    { link: "/about", text: "About" },
    { link: "/portfolio", text: "Portfolio" },
    { link: "/contact", text: "Contact Us" },
  ];
  constructor() {}

  ngOnInit(): void {}

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
